import React from "react";
import t from "../Language/language";
import * as languageSettings from "../Language/languageSettings";

export default class LBGroupStoresList extends React.Component {
  constructor(props) {
    super();
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      isViewMyStoresOnlyChecked: false
    };
    this.viewMystoresOnly = this.viewMystoresOnly.bind(this);
  }

  renderLable(item) {
    return item.StoreName ? item.StoreNumber + " - " + item.StoreName : item.StoreNumber;
  }

  viewMystoresOnly() {
    console.log(this.state.isViewMyStoresOnlyChecked)
    this.setState({isViewMyStoresOnlyChecked: !this.state.isViewMyStoresOnlyChecked})
  }

  //Method that renders each individual row that exists inside the LB Group Stores Modal
  renderStores() {
    let self = this;
    const { language, isViewMyStoresOnlyChecked } = self.state;

    if (this.props != undefined) {
      let props = this.props;

      let storeRows = props.items.map(function(store, index) {
        let isOtherLBStore = props.company.companyUId !== store.CompanyUID;
        if (store.selected == undefined) {
          store.selected = false;
        }
        return (
          <tr className={"tdata clear " + (isOtherLBStore ? " greyed-row" : "") + (isViewMyStoresOnlyChecked && isOtherLBStore ? ' hidden': '')} key={index}>
            <td className={"cdet store_checkbox"}>
              <label className={"participant-stores-checkbox " + (props.isDefault || isOtherLBStore  ? "hidden" : "")}>
                <input
                  type="checkbox"
                  checked={store.selected}
                  disabled={isOtherLBStore || props.isDefault}
                  name="availableItem"
                  id={props.type}
                  onChange={e => props.toggle(store)}
                />
                <span></span>
              </label>
            </td>
            <td title={store.StoreNumber + "-" + (store.StoreName || store.StoreNumber)}>{store.StoreNumber} - {store.StoreName || store.StoreNumber}</td>
          </tr>
        );
      });

      return storeRows;
    } else {
      return (
        <tr>
          <td>{t[language].noStoresFound}</td>
        </tr>
      );
    }
  }

  render() {
    const language = this.state.language;
    return (
      <div className="col-xs-12 col-sm-12 col-md-5">
        <div className="lbGroupinputs">
          <b className="participating-table-title">{this.props.title}</b>
          <label className={"participant-stores-checkbox select-all-chechbox" + (this.props.isDefault ? " hidden" : "")}>
            <input
              type="checkbox"
              onChange={e => this.props.selectAll(e, this.props.items)}
              name="selectAll"
              id={this.props.type}
              className={this.props.isDefault ? " hidden" : ""}
            />
            <span></span>
          </label>
          <span className={"textPaddingSmall" + (this.props.isDefault ? " hidden" : "")}>
              &nbsp;
              {t[language].selectall}
            </span>
          <label className={"participant-stores-checkbox my-stores-chechbox"}>
            <input
              type="checkbox"
              onChange={this.viewMystoresOnly}
              value={this.state.isViewMyStoresOnlyChecked}
              name="viewMyStoresOnly"
              className={this.props.isDefault ? " hidden" : ""}
            />
            <span></span>
          </label>
          <span>
              &nbsp;
              {t[language].ViewMyStoresOnly}
            </span>
        </div>
        <div className="lbGrouptable">
          <div className="storeAssignment lbGroupTable">
            <table >
              <tbody className="list-body">{this.renderStores()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LeaderBoard/LBGroupTable.js